import { Breadcrumb } from '@interfaces/models/breadcrumb';
import Breadcrumbs from '@components/molecules/products/breadcrumbs/breadcrumbs';
import clsx from 'clsx';
import React from 'react';
import useGuidedSearchQuery from '@hooks/catalog-context/use-guided-search-query';
import { useRouter } from 'next/router';
import { isDealHuntingLandingPage, isPersonalizedNewInsPage } from '@helpers/routing';
import dynamic from 'next/dynamic';
import styles from './catalog-header.module.scss';

const CatalogHeaderNavigation = dynamic(
  () => import('@components/catalog/catalog-header-navigation/catalog-header-navigation'),
);

export type CatalogHeaderProps = {
  title: string;
  subtitle?: string;
  breadcrumbs: Breadcrumb[];
  customClassName?: string;
} & React.HTMLProps<HTMLDivElement>;

const CatalogHeader: React.FC<CatalogHeaderProps> = (props) => {
  const { title, breadcrumbs, customClassName, subtitle } = props;
  const { asPath, query } = useRouter();

  const { showCarousel } = useGuidedSearchQuery();
  const showBreadcrumb = !(isDealHuntingLandingPage(query) || isPersonalizedNewInsPage(asPath));

  return (
    <div
      className={clsx(styles.catalogHeader, showCarousel && styles['catalogHeader--withNavigation'], customClassName)}
    >
      <div className={styles.catalogHeader__mainHeading}>
        {breadcrumbs && showBreadcrumb && (
          <div className={clsx(styles.productPage__top__breadcrumb, 'd-md-block')}>
            <Breadcrumbs
              breadcrumbs={breadcrumbs}
              isCatalogPage
            />
          </div>
        )}
        <span className={clsx(styles.catalogHeader__mainTitle, 'vc-title-m')}>{title}</span>
        {subtitle && <span className={clsx(styles.catalogHeader__subtitle)}>{subtitle}</span>}
        {showCarousel && <CatalogHeaderNavigation />}
      </div>
    </div>
  );
};

export default CatalogHeader;
